import React, { Component } from "react";
import Quagga from "quagga";

export default class Scanner extends Component {
  constructor(props) {
    super(props);
    this.onDetected = this.onDetected.bind(this);
  }

  componentDidMount() {
    Quagga.init(
      {
        inputStream: {
          name: "Live",
          type: "LiveStream",
          constraints: {
            width: 320,
            facingMode: "environment",
          },
        },
        debug: {
          drawBoundingBox: true,
          drawScanline: true
        },
        decoder: {
          readers: ["ean_reader"]
        },
        locate: true
      },
      function(err) {
        if (err) {
          console.log(err);
          return;
        }
        Quagga.start();
      }
    );
    Quagga.onDetected(this.onDetected);
    Quagga.onProcessed(this.onProcessed);
  }

  componentWillUnmount() {
    Quagga.offDetected(this.onDetected);
  }

  onProcessed(result) {
    const drawingCtx = Quagga.canvas.ctx.overlay;
    const drawingCanvas = Quagga.canvas.dom.overlay;

    if (result) {
      if (result.boxes) {
        drawingCtx.clearRect(
          0,
          0,
          parseInt(drawingCanvas.getAttribute("width"), 10),
          parseInt(drawingCanvas.getAttribute("height"), 10)
        );
        result.boxes
          .filter(function(box) {
            return box !== result.box;
          })
          .forEach(function(box) {
            Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
              color: "green",
              lineWidth: 2
            });
          });
      }

      if (result.box) {
        Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
          color: "#00F",
          lineWidth: 2
        });
      }

      if (result.codeResult && result.codeResult.code) {
        Quagga.ImageDebug.drawPath(
          result.line,
          { x: "x", y: "y" },
          drawingCtx,
          { color: "red", lineWidth: 3 }
        );
      }
    }
  }

  onDetected(result) {
    const { onDetected } = this.props;
    onDetected(result);
  }

  render() {
    return <div id="interactive" className="barcode-scan viewport" />;
  }
}



// WEBPACK FOOTER //
// ./src/views/controls/_Scanner.js